"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.TabPanel = exports.TabLabel = exports.Tab = exports.TabsList = exports.Tabs = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var Tabs = _styledComponents["default"].div.withConfig({
  displayName: "styles__Tabs"
})([""]);

exports.Tabs = Tabs;

var TabsList = _styledComponents["default"].div.withConfig({
  displayName: "styles__TabsList"
})(["display:flex;"]);

exports.TabsList = TabsList;

var Tab = _styledComponents["default"].div.withConfig({
  displayName: "styles__Tab"
})([""]);

exports.Tab = Tab;

var TabLabel = _styledComponents["default"].div.withConfig({
  displayName: "styles__TabLabel"
})(["height:45px;min-width:45px;cursor:pointer;border:1px solid ", ";margin-right:1rem;display:flex;align-items:center;justify-content:center;&:last-child{margin-right:0;}"], function (a) {
  return a.isActive ? "red" : "black";
});

exports.TabLabel = TabLabel;

var TabPanel = _styledComponents["default"].div.withConfig({
  displayName: "styles__TabPanel"
})(["padding:1rem;border:2px solid black;"]);

exports.TabPanel = TabPanel;